// Avatar utility functions for user photos and gradient colors

// Predefined gradient color combinations
const GRADIENT_COLORS = [
    'from-blue-500 to-purple-600',
    'from-green-500 to-teal-600',
    'from-pink-500 to-rose-600',
    'from-yellow-500 to-orange-600',
    'from-indigo-500 to-blue-600',
    'from-emerald-500 to-green-600',
    'from-violet-500 to-purple-600',
    'from-amber-500 to-yellow-600',
    'from-cyan-500 to-blue-600',
    'from-lime-500 to-green-600',
    'from-red-500 to-pink-600',
    'from-slate-500 to-gray-600',
    'from-stone-500 to-neutral-600',
    'from-zinc-500 to-gray-600',
    'from-orange-500 to-red-600',
    'from-teal-500 to-cyan-600',
] as const;

/**
 * Generate a consistent gradient color for a user based on their ID or name
 */
export function generateUserGradient(userId: number | string, userName?: string): string {
    // Use user ID if available, otherwise hash the name
    const seed = typeof userId === 'number' ? userId : hashString(userName || userId.toString());
    const index = Math.abs(seed) % GRADIENT_COLORS.length;
    return GRADIENT_COLORS[index];
}

/**
 * Simple hash function for strings
 */
function hashString(str: string): number {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash; // Convert to 32-bit integer
    }
    return hash;
}

/**
 * Get user initials from name
 */
export function getUserInitials(name: string | undefined | null): string {
    if (!name) return 'U'
    return name
        .split(' ')
        .map(word => word.charAt(0).toUpperCase())
        .slice(0, 2)
        .join('');
}

/**
 * Check if a URL is a valid image
 */
export function isValidImageUrl(url: string): boolean {
    try {
        const urlObj = new URL(url);
        const pathname = urlObj.pathname.toLowerCase();
        const validExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg'];
        return validExtensions.some(ext => pathname.endsWith(ext));
    } catch {
        return false;
    }
}

/**
 * Generate a random gradient color (for new users)
 */
export function getRandomGradient(): string {
    const index = Math.floor(Math.random() * GRADIENT_COLORS.length);
    return GRADIENT_COLORS[index];
}
